import createAction from "../../app/createAction";
import {
    AUTO_LOGIN_FAILURE,
    AUTO_LOGIN_START,
    AUTO_LOGIN_SUCCESS,
    CHECK_CODE_FAILURE,
    CHECK_CODE_START,
    CHECK_CODE_SUCCESS,
    CREATE_PASSWORD_FAILURE,
    CREATE_PASSWORD_START,
    CREATE_PASSWORD_SUCCESS,
    LOGIN_FAILURE,
    LOGIN_START,
    LOGIN_SUCCESS,
    LOGOUT_FAILURE,
    LOGOUT_START,
    LOGOUT_SUCCESS,
    PASSWORD_RESET_FAILURE,
    PASSWORD_RESET_RESET,
    PASSWORD_RESET_START,
    PASSWORD_RESET_SUCCESS,
    PASSWORD_UPDATE_FAILURE,
    PASSWORD_UPDATE_START,
    PASSWORD_UPDATE_SUCCESS,
    REGISTRATION_FAILURE,
    REGISTRATION_PREPARE,
    REGISTRATION_START,
    REGISTRATION_SUCCESS,
    RESEND_CODE_FAILURE,
    RESEND_CODE_START,
    RESEND_CODE_SUCCESS,
    SET_CHANGE_EMAIL_FAILURE,
    SET_CHANGE_EMAIL_START,
    SET_CHANGE_EMAIL_SUCCESS,
    SET_REGISTRATION_DATA,
} from "./loginConstants";

export const loginAction = (payload) => createAction(LOGIN_START, payload);
export const loginSuccess = (payload) => createAction(LOGIN_SUCCESS, payload);
export const loginFailure = (payload) => createAction(LOGIN_FAILURE, payload);

export const logoutAction = (payload) => createAction(LOGOUT_START, payload);
export const logoutSuccess = (payload) => createAction(LOGOUT_SUCCESS, payload);
export const logoutFailure = (payload) => createAction(LOGOUT_FAILURE, payload);

export const registrationAction = (payload) => createAction(REGISTRATION_START, payload);
export const registrationSuccess = (payload) => createAction(REGISTRATION_SUCCESS, payload);
export const registrationFailure = (payload) => createAction(REGISTRATION_FAILURE, payload);

export const setRegistrationDataAction = (payload) => createAction(SET_REGISTRATION_DATA, payload);
export const registrationPrepareAction = (payload) => createAction(REGISTRATION_PREPARE, payload);

export const passwordResetAction = (payload) => createAction(PASSWORD_RESET_START, payload);
export const passwordResetSuccess = (payload) => createAction(PASSWORD_RESET_SUCCESS, payload);
export const passwordResetFailure = (payload) => createAction(PASSWORD_RESET_FAILURE, payload);
export const passwordResetReset = (payload) => createAction(PASSWORD_RESET_RESET, payload);

export const passwordUpdateAction = (payload) => createAction(PASSWORD_UPDATE_START, payload);
export const passwordUpdateSuccess = (payload) => createAction(PASSWORD_UPDATE_SUCCESS, payload);
export const passwordUpdateFailure = (payload) => createAction(PASSWORD_UPDATE_FAILURE, payload);

export const setChangeEmailAction = (payload) => createAction(SET_CHANGE_EMAIL_START, payload);
export const setChangeEmailSuccess = (payload) => createAction(SET_CHANGE_EMAIL_SUCCESS, payload);
export const setChangeEmailFailure = (payload) => createAction(SET_CHANGE_EMAIL_FAILURE, payload);

export const checkCodeAction = (payload) => createAction(CHECK_CODE_START, payload);
export const checkCodeSuccess = (payload) => createAction(CHECK_CODE_SUCCESS, payload);
export const checkCodeFailure = (payload) => createAction(CHECK_CODE_FAILURE, payload);

export const createPasswordAction = (payload) => createAction(CREATE_PASSWORD_START, payload);
export const createPasswordSuccess = (payload) => createAction(CREATE_PASSWORD_SUCCESS, payload);
export const createPasswordFailure = (payload) => createAction(CREATE_PASSWORD_FAILURE, payload);

export const resendCodeAction = (payload) => createAction(RESEND_CODE_START, payload);
export const resendCodeSuccess = (payload) => createAction(RESEND_CODE_SUCCESS, payload);
export const resendCodeFailure = (payload) => createAction(RESEND_CODE_FAILURE, payload);

export const autoLoginAction = (payload) => createAction(AUTO_LOGIN_START, payload);
export const autoLoginSuccess = (payload) => createAction(AUTO_LOGIN_SUCCESS, payload);
export const autoLoginFailure = (payload) => createAction(AUTO_LOGIN_FAILURE, payload);
